const websocketUrl = 'https://127.0.0.1:63117';

class AutofirmaWebsocketManager {

    private websocket: WebSocket;

    constructor(onOpen: () => void, onFileSigned: (data: string) => void) {
        this.websocket = new WebSocket(websocketUrl);

        this.websocket.onopen = () => {
            onOpen();
        };

        this.websocket.onmessage = (event) => {
            onFileSigned(event.data);
        };

        this.websocket.onclose = () => {
            console.log('Conexión cerrada con Autofirma');
        };

        this.websocket.onerror = (error) => {
            console.error('Error en conexión con AutoFirma:', error);
        };
    }

    public sendMessage(message: string) {
        this.websocket.send(message);
    }

    public close() {
        this.websocket.close();
    }

}

export default AutofirmaWebsocketManager;